type ProductData = {
  value: number;
  currency: string;
  content_name: string;
  content_type: string;
  content_ids: string[];
  num_items: number;
};

type Fbq = {
  (...args: unknown[]): void;
  callMethod?: (...args: unknown[]) => void;
  queue: unknown[];
  push: Fbq;
  loaded: boolean;
  version: string;
};

declare global {
  interface Window {
    fbq?: Fbq;
    _fbq?: Fbq;
    dataLayer?: Record<string, unknown>[];
  }
}

const PIXEL_ID = "1768473210916570";
const PRODUCT_NAME = "Equilibrio 60+";
const PRODUCT_ID = "84da98c1-f8fb-49a7-90d8-18b283526d77";

let pixelInitialized = false;

export function initMetaPixel() {
  if (pixelInitialized || typeof window === "undefined") return;
  pixelInitialized = true;

  if (!window.fbq) {
    const n = function (...args: unknown[]) {
      if (n.callMethod) n.callMethod(...args);
      else n.queue.push(args);
    } as Fbq;
    if (!window._fbq) window._fbq = n;
    n.push = n;
    n.loaded = true;
    n.version = "2.0";
    n.queue = [];
    window.fbq = n;

    const t = document.createElement("script");
    t.async = true;
    t.src = "https://connect.facebook.net/en_US/fbevents.js";
    const s = document.getElementsByTagName("script")[0];
    if (s && s.parentNode) s.parentNode.insertBefore(t, s);
    else document.head.appendChild(t);
  }

  window.fbq("init", PIXEL_ID);
  window.fbq("track", "PageView");
}

export function parsePrice(text: string): number {
  let s = text.replace(/[^0-9.,]/g, "");
  if (s.indexOf(",") > -1) {
    s = s.replace(/\./g, "").replace(",", ".");
  } else {
    const p = s.split(".");
    if (p.length > 1 && p[p.length - 1].length === 3) s = s.replace(/\./g, "");
  }
  return parseFloat(s) || 0;
}

function currency(): string {
  const el = document.getElementById("store-currency") as HTMLInputElement | null;
  return el && el.value ? el.value : "USD";
}

function productData(price: string): ProductData {
  return {
    value: parsePrice(price),
    currency: currency(),
    content_name: PRODUCT_NAME,
    content_type: "product",
    content_ids: [PRODUCT_ID],
    num_items: 1,
  };
}

function pushDataLayer(event: string, price: string) {
  try {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event,
      item_name: PRODUCT_NAME,
      value: parsePrice(price),
      currency: currency(),
    });
  } catch {
    /* noop */
  }
}

function fbTrack(event: string, price: string) {
  try {
    window.fbq?.("track", event, productData(price));
  } catch {
    /* noop */
  }
}

export function trackViewContent(price: string) {
  fbTrack("ViewContent", price);
  pushDataLayer("ViewContent", price);
}

export function trackInitiateCheckout(price: string) {
  fbTrack("InitiateCheckout", price);
  pushDataLayer("InitiateCheckout", price);
}
